/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_PRODUCT = gql`
    query Query(
        $barcode: String
        $nfcHash: String
        $latitude: Float
        $longitude: Float
        $v2Batch: String
    ) {
        getV2Provenance(
            barcode: $barcode
            nfcHash: $nfcHash
            latitude: $latitude
            longitude: $longitude
            v2Batch: $v2Batch
        ) {
            v2ProvData
            version
            isValid
            v1ProvData
        }
    }
`;
